export const rules = {
  password : {
    min: 6,
    max: 24
  }
}